import styled, { css } from "styled-components";
export const ShapeContainer = styled.div `
	${({ color }) => color
    ? css `
					background-color: var(${color});
			  `
    : css `
					background-color: var(--border-primary);
			  `}
	${({ height }) => height
    ? css `
					height: ${height};
			  `
    : css `
					height: 30px;
			  `}
	${({ width }) => width
    ? css `
					min-width: ${width};
					width: ${width};
			  `
    : css `
					width: 30px;
			  `}
	${({ shape }) => shape === "circle" &&
    css `
			clip-path: circle(50% at 50% 50%);
		`}
	${({ shape }) => shape === "square" &&
    css `
			clip-path: inset(5% 20% 15% 10%);
		`}
	${({ shape }) => shape === "triangle" &&
    css `
			clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
		`}
`;
//# sourceMappingURL=styles.js.map